<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      search_route="/shipping-policy/add"
      search_title="اضافه جديد"
      icon="fa-plus"
    />
    <!-- End Breadcrumb -->

    <!-- Start Statistics Card-->
    <!-- <div class="row mb-5">
      <div class="wrraper">
        <stats-card :number="rows.length"></stats-card>
      </div>
    </div> -->
    <!-- End Statistics Card-->

    <!-- Start Main Section -->
    <!-- v-model="selected"
        show-select
        :single-select="singleSelect" -->
    <main>
      <v-data-table
        class="thumb strip"
        :headers="headers"
        :items="rows"
        :search="search"
        :loading="lodaing"
        :loading-text="$t('table.loadingData')"
        item-key="id"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- ================== You Can use any slots you want ================== -->
        <!-- <template v-slot:[`item.images.ar`]="{ item }">
          <img @click="show_model_1" class="image" :src="item.images.ar" />
        </template> -->
        <!-- ====== Select row field ====== -->
        <template v-slot:[`item.description`]="{ item }">
          <!-- <img @click="show_model_1" class="image" :src="item.images.ar" /> -->
          <button
            style="font-size: 20px"
            @click="showDescModel(item.description)"
          >
            <i class="fas fa-eye"></i>
          </button>
        </template>

        <!-- Select no data State -->
        <template v-slot:no-data>
          {{ $t("table.noData") }}
        </template>

        <template v-slot:[`item.user_type`]="{ item }">
          {{
            item.user_type == "client"
              ? "عميل"
              : item.user_type == "driver"
              ? "سائق"
              : "متجر"
          }}
        </template>

        <!-- Select actions-->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="_actions">
            <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
            <v-icon
              class="edit"
              small
              @click="editItem(item)"
              v-if="helper_hasPermission('edit')"
            >
              fal fa-edit
            </v-icon>
            <v-icon
              class="delete"
              small
              @click="deleteItem(item)"
              v-if="helper_hasPermission('delete')"
            >
              fal fa-trash
            </v-icon>
          </div>
        </template>

        <!-- ======================== Start Top Section ======================== -->
        <template v-slot:top>
          <h3 class="table-title title">
            {{ $t("breadcrumb.shipping_policy.title") }}
            <span class="total">({{ total }})</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  far fa-info-circle
                </v-icon>
              </template>
              <span>Tooltip</span>
            </v-tooltip>
          </h3>
          <!-- Delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("table.deletedialog.areYouSure") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteItemConfirm">
                  {{ $t("table.deletedialog.ok") }}
                </v-btn>
                <v-btn color="#F44336" @click="dialogDelete = false">
                  {{ $t("table.deletedialog.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Add & Delete -->
        </template>
        <!-- ======================== End Top Section ======================== -->
      </v-data-table>
    </main>
    <!-- End Main Section -->
    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <v-dialog v-model="descModel" width="800">
      <v-card class="text-center p-3">
        <div v-html="descContent"></div>
      </v-card>
    </v-dialog>
    <!-- End Image_Model -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      total: null,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.shipping_policy.title"),
          disabled: false,
          href: "/shipping-policy/show-all",
        },
        {
          text: this.$t("breadcrumb.shipping_policy.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [],

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      // ========== Loding
      lodaing: false,
      descModel: false,
      descContent: null,
    };
  },

  watch: {
    [`paginations.current_page`]() {
      this.setRows();
    },
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          // {
          //   text: "الصورة",
          //   align: "center",
          //   value: "images.ar",
          //   sortable: false,
          // },
          {
            text: "العنوان",
            align: "center",
            value: "name",
            sortable: false,
          },
          {
            text: "الوصف",
            align: "center",
            value: "description",
            sortable: false,
          },
          {
            text: "نوع المستخدم",
            align: "center",
            value: "user_type",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "Image",
            align: "center",
            value: "images.en",
            sortable: false,
          },
          {
            text: "Title",
            align: "center",
            value: "en[title]",
            sortable: false,
          },
          {
            text: "Description",
            align: "center",
            value: "en[desc]",
            sortable: false,
          },
          {
            text: "Slug",
            align: "center",
            value: "en[slug]",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      }
    },
  },

  methods: {
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    showDescModel(desc) {
      this.descModel = true;
      this.descContent = desc;
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/shipping-policy/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/shipping-policy/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/shipping-policy/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `shipping_policy/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    deleteSelected() {
      this.dialogDelete_selected = true;
    },
    deleteSelectedConfirm() {
      this.$axios({
        method: "POST",
        url: `shipping_policy/deleteAll`,
        data: { ids: this.selected.map((item) => item.id) },
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return !this.selected.filter((obj) => obj.id == item.id).length > 0;
          });
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.lodaing = true;
      this.$axios({
        method: "GET",
        url: "shipping_policy",
      })
        .then((res) => {
          this.rows = res.data.data;
          this.total = res.data.meta?.total;
          this.lodaing = false;
        })
        .catch(() => {
          this.lodaing = false;
        });
    },
  },

  // ======= hooks
  created() {
    // Set Rows
    this.setRows();
  },
};
</script>
